import DotsLoading from './DotsLoading';
export default DotsLoading;
